import { ReactNode, useEffect, useMemo, useState } from "react";
import { createPortal } from "react-dom";

interface FixedBottomBarPortalProps {
  children: ReactNode;
}

/**
 * Renders children into document.body.
 * Needed because our route wrapper uses CSS transforms (framer-motion PageTransition),
 * which breaks `position: fixed` when rendered inside the transformed element.
 */
export function FixedBottomBarPortal({ children }: FixedBottomBarPortalProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  const target = useMemo(() => {
    if (typeof document === "undefined") return null;
    return document.body;
  }, []);

  if (!mounted || !target) return null;

  return createPortal(children, target);
}
